import React from 'react'
import {useUserRoles} from '../utils/use-user-roles'
import NotFoundPage from '../components/not-found-page'
import {getAuthByRole} from '../utils/get-screen-auth-by-role'
import {AUTHORIZED_ROLES_BY_SCREENS} from '../utils/constants'
import AdminControlCenterScreen from '../components/control-center-admin.js/control-center-admin-screen'

const ControlCenterAdmin = () => {
  const {roles} = useUserRoles()

  if (!getAuthByRole(AUTHORIZED_ROLES_BY_SCREENS.adminClientCenter, roles)) {
    return <NotFoundPage />
  }

  return <AdminControlCenterScreen />
}

export {ControlCenterAdmin}
